import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  hasSearchQuery: boolean
}

const EmptyDocusignTemplatesComponent = ({ hasSearchQuery }: Props) => {
  return (
    <div
      data-testid="docusign-templates-list-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">No DocuSign templates found</Typography>
      <Typography variant="body2" css={tw`text-shades-500`}>
        {hasSearchQuery ? 'Try a different search.' : 'Add a template to get started.'}
      </Typography>
    </div>
  )
}

export const EmptyDocusignTemplates = memo(EmptyDocusignTemplatesComponent)
